import { useEffect } from 'react';
import useRouter from 'AppShell/hooks/useRouter';
import { getUrlParameter } from '../../common/helpers/urlHelpers';

enum Actions {
    PUSH = 'PUSH',
}

const ScrollToTop = () => {
    const { location, history } = useRouter();
    const { pathname, search } = location;
    const { action } = history;
    const page = getUrlParameter(search, 'page');
    const shouldScroll = action === Actions.PUSH;

    useEffect(() => {
        if (shouldScroll) {
            window.scrollTo(0, 0);
        }
    }, [pathname, page, shouldScroll]);

    return null;
};

export default ScrollToTop;
